export class Domicilio {
  constructor() {
    this.direccion = '';
    this.localidad = '';
    this.pais = { id:1, nombre: 'Argentina'};
    this.provincia = { id:14, nombre: 'NEUQUEN'};
    this.departamento = '';
  }
}



// WEBPACK FOOTER //
// ./src/model/Domicilio.js